module.exports = __webpack_public_path__ + "img/shareHeader.97d1d1a8.png";